import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';

const defaultsearchtext = ''

const BySearchField = (props) => {

    const [searchString, setSearchString] = useState('')
    const [btnactive, setBtnactive] = useState(true)
    const [clsstate, setClsstate] = useState('')
    const [showclose, setShowclose] = useState(false)

    useEffect(() => {
        let ritems = props.ritems        
        ritems && ritems.length > 0 && setClsstate('error')
    },[props.ritems])

    useEffect(() => {
        if(props.categorytext){            
            setClsstate('active')
            setSearchString(props.categorytext)
            categorytextUpdate(props.categorytext)            
        }
        setSearchString(sessionStorage.getItem('searchRecipeText') || '')
        if(sessionStorage.getItem('searchRecipeText')){
            setShowclose(true)
            setClsstate('active')
            setBtnactive(false)
        }
    },[props.categorytext])

    const categorytextUpdate = (text) => {        
        props.getSearchFieldData(text)
    }

    const handleChange = (e) => {
        setClsstate('')
        setShowclose(false)
        if(e.target.value.length !== 0){            
            setBtnactive(false)
            setSearchString(e.target.value)
        } else {            
            setBtnactive(true)
            setSearchString(defaultsearchtext)
            props.getSearchFieldData(defaultsearchtext)
        }        
    }
    const handleClick = (e) => {
        e.preventDefault()
        if(!btnactive){
            props.getSearchFieldData(searchString)
            setClsstate('active')
            setShowclose(true)
        }
    }

    const handleClose = (e) => {
        e.preventDefault()
        setSearchString(defaultsearchtext)
        props.getSearchFieldData(defaultsearchtext)
        setShowclose(false)
        setClsstate(defaultsearchtext)
        setBtnactive(true)
    }

    const restrictSpecialChar = (e) => {
        var key = e.keyCode ? e.keyCode : e.which;
        if(key === 13) handleClick(e)
        if (!( (key >= 48 && key <= 57) 
        ||(key >= 65 && key <= 90) 
        || (key >= 97 && key <= 122) ) 
        && key != 8 && key != 32) e.preventDefault()
}

    const {t} = props

    return (
        <div className={`fields fields-searchtext fields-${clsstate}`}>
            <form
                role="search"
                id="searchform"
                className="searchform"
                onSubmit={handleClick}
            >
                <div className="searchfield">
                    <input
                        type="text"
                        value={searchString}
                        onChange={(e) => handleChange(e)}
                        onKeyPress={restrictSpecialChar}
                        placeholder={t('RecipeFinder_SearchBoxPlaceholder')}                        
                    />
                    <button className="btn" type="submit" disabled={btnactive}>
                        {
                            !showclose ?
                            <i
                                className="fa fa-search"
                                onClick={(e) => handleClick(e)}
                                aria-hidden="true"
                            /> :
                            <i
                                className="fa fa-times"
                                onClick={(e) => handleClose(e)}
                                aria-hidden="true"
                            />
                        }
                    </button>
                </div>
            </form>
        </div>
    )
};

export default withTranslation()(BySearchField);
